<template>
	<div
		class="position-relative d-flex align-items-center justify-content-center overflow-hidden"
		:style="{
			width: typeof width === 'number' ? width + 'px' : width,
			height: typeof height === 'number' ? height + 'px' : height,
			borderRadius: shape === 'circle' ? '50%' : '0',
		}"
	>
		<!-- Скелетон / спиннер / иконка -->
		<div
			v-if="!loaded && !error"
			class="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center"
		>
			<!-- shimmer / pulse -->
			<template v-if="skeleton === 'shimmer' || skeleton === 'pulse'">
				<div
					class="w-100 h-100"
					:class="[
						{
							'rounded-circle': shape === 'circle',
						},
						`skeleton-${skeleton}`,
					]"
				></div>
			</template>

			<!-- spinner -->
			<template v-else-if="skeleton === 'spinner'">
				<slot name="spinner">
					<div
						:class="[
							spinnerType === 'grow'
								? 'spinner-grow'
								: 'spinner-border',
							spinnerSize ? `spinner-${spinnerSize}` : '',
							`text-${spinnerColor}`,
						]"
						role="status"
					>
						<span class="visually-hidden">Загрузка...</span>
					</div>
				</slot>
			</template>

			<!-- default placeholder -->
			<template v-else>
				<slot name="placeholder">
					<font-awesome-icon :icon="['fas', 'image']" class="text-secondary fs-2" />
				</slot>
			</template>
		</div>

		<!-- Картинка -->
		<img
			v-show="loaded"
			:src="src"
			:alt="alt"
			:style="{
				objectFit: fit,
				borderRadius: shape === 'circle' ? '50%' : '0',
			}"
			class="w-100 h-100 transition-opacity"
			:class="{
				'opacity-0': !loaded,
				'opacity-100': loaded,
			}"
			@load="onLoad"
			@error="onError"
		/>

		<!-- Ошибка -->
		<div
			v-if="error"
			class="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center text-danger bg-body-secondary"
		>
			<slot name="error">
				<font-awesome-icon :icon="['fas', 'triangle-exclamation']" class="fs-4" />
			</slot>
		</div>
	</div>
</template>

<style lang="scss" scoped>
/* shimmer */
.skeleton-shimmer {
	background: linear-gradient(
		90deg,
		var(--bs-tertiary-bg, #e9ecef) 25%,
		var(--bs-body-bg, #f8f9fa) 50%,
		var(--bs-tertiary-bg, #e9ecef) 75%
	);
	background-size: 200% 100%;
	animation: skeleton-shimmer 1.5s infinite;
}
@keyframes skeleton-shimmer {
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
}

/* pulse */
.skeleton-pulse {
	background: var(--bs-tertiary-bg, #e9ecef);
	animation: skeleton-pulse 1.5s ease-in-out infinite;
}
@keyframes skeleton-pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

/* плавное появление */
.transition-opacity {
	transition: opacity 0.5s ease-in-out;
}
.opacity-0 {
	opacity: 0;
}
.opacity-100 {
	opacity: 1;
}
</style>

<script>
import lib from "@/lib";

export default {
	name: "ImageWithPlaceholderComponent",
	mixins: lib.mixins,
	props: {
		src: {
			type: String,
			required: true,
		},
		alt: {
			type: String,
			default: "",
		},
		width: {
			type: [String, Number],
			default: "100%",
		},
		height: {
			type: [String, Number],
			default: "auto",
		},
		fit: {
			type: String,
			default: "contain", // cover | contain | fill
		},
		skeleton: {
			type: String,
			default: "", // shimmer | pulse | spinner | false
		},
		shape: {
			type: String,
			default: "rect",
		}, // rect | circle
		spinnerType: {
			type: String,
			default: "border", // border | grow
		},
		spinnerColor: {
			type: String,
			default: "secondary", // Bootstrap text-*
		},
		spinnerSize: {
			type: String,
			default: "", // sm | lg | ""
		},
	},
	data: () => ({
		loaded: false,
		error: false,
	}),
	watch: {
		src() {
			this.loaded = false;
			this.error = false;
		}
	},
	methods: {
		onLoad() {
			this.loaded = true;
		},
		onError() {
			this.error = true;
		},
	},
};
</script>
